// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myimg {
  margin: auto;
  width: calc(113 * var(--width-ratio));
  height: calc(108 * var(--width-ratio));
}

.mybutton {
  --background: var(--ion-color-primary);
  width: calc(253 * var(--width-ratio));
  height: calc(42 * var(--width-ratio));
  --border-radius: 30px;
}

ion-content {
  --overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/login-popup-modal/login-popup-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,qCAAA;EACA,sCAAA;AACF;;AAEA;EACE,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".myimg {\n  margin: auto;\n  width: calc(113 * var(--width-ratio));\n  height: calc(108 * var(--width-ratio));\n}\n\n.mybutton {\n  --background: var(--ion-color-primary);\n  width: calc(253 * var(--width-ratio));\n  height: calc(42 * var(--width-ratio));\n  --border-radius: 30px;\n}\n\nion-content {\n  --overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
